// ============================================================================
// CANCELLATION SERVICE
// ============================================================================

import { get, post } from '../client/axiosClient';
import { cancellationEndpoints } from '../endpoints/cancellation.endpoints';
import type { ApiResponse, ID } from '../types';
import type { CancelBookingRequest, Cancellation } from '../types/cancellation.types';

class CancellationService {
  async cancel(bookingId: ID, payload: CancelBookingRequest): Promise<Cancellation> {
    const response = await post<ApiResponse<Cancellation>>(
      cancellationEndpoints.cancel(bookingId),
      payload,
    );
    if (!response.data?.data) {
      throw new Error(response.data?.message || 'Failed to cancel booking.');
    }
    return response.data.data;
  }

  async getByBooking(bookingId: ID): Promise<Cancellation | null> {
    try {
      const response = await get<ApiResponse<Cancellation>>(
        cancellationEndpoints.getByBooking(bookingId),
      );
      return response.data?.data ?? null;
    } catch (err: any) {
      // 404 expected when the booking has not been cancelled.
      if (err?.response?.status === 404) return null;
      throw err;
    }
  }
}

export const cancellationService = new CancellationService();
export default cancellationService;
